import { c as _c } from "react/compiler-runtime";
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
const DropzoneUploadWrapper = t0 => {
  const $ = _c(5);
  const {
    children,
    allowUploads: t1
  } = t0;
  const allowUploads = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== allowUploads) {
    t2 = classNames("rounded-sm", {
      "border border-dashed border-gray-light6 cursor-pointer": allowUploads
    });
    $[0] = allowUploads;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children || $[3] !== t2) {
    t3 = <div className={t2}>{children}</div>;
    $[2] = children;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
DropzoneUploadWrapper.propTypes = {
  children: PropTypes.node,
  allowUploads: PropTypes.bool
};
export default DropzoneUploadWrapper;